import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';

import DatePicker from 'react-date-picker';


const DirectDB = ({ is_admin }) => {

    const [log_date, setLog_date] = useState(new Date())
    return (
        <Fragment>
            <div className="container">

                {is_admin === 2 ? <h1>Direct DB Management</h1> : <h1>View DB Management</h1>}

                {is_admin === 2 ? <h6>Here, you have direct control over the database</h6> : <h6>Here, you have direct viewing power over the database</h6>}

                <h6>List</h6>
                {is_admin >= 1 && <Link to="/ShiftListAll"><button className="btn btn-info my-2 mr-2">See all shifts</button></Link>}
                {is_admin >= 1 && <Link to="/WorkerList"><button className="btn btn-info my-2 mr-2" >See all workers</button></Link>}
                {is_admin >= 1 && <Link to="/ClientList"><button className="btn btn-info my-2 mr-2">See all clients</button></Link>}
                {is_admin >= 1 && <Link to="/ExpenseList"><button className="btn btn-info my-2 mr-2">See all expenses</button></Link>}
                <div className="mt-2 d-flex">
                <DatePicker onChange={setLog_date} value={log_date} />
                {is_admin === 2 && log_date != null && <Link to={"/ServerLog/"+log_date.toLocaleDateString().replace('/','-').replace('/','-')}><button className="btn btn-info ml-2">ServerLogs</button></Link>}
                </div>
                {is_admin === 2 && <Link to={"/DatabaseReset"}><button className="btn btn-warning mt-2">Reset Database From Backup</button></Link>}
            </div>
        </Fragment>
    )
}

export default DirectDB;
